<template>
    <div class="spinner-wrap">
        <div :style="{borderColor: color}"></div>
    </div>
</template>

<script>
    export default {
        name: 'loader',
        props: {
            color: {
                type: String,
                default: '#7599DC'
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/globals";

    .spinner-wrap {
        position: relative;
        width: 1em;
        height: 1em;

        & > div {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            border-radius: 50%;
            border: 2px solid $blue;
            border-bottom-color: transparent !important;
            height: 1em;
            width: 1em;
            display: block;
            animation-fill-mode: both;
            animation: rotate 0.75s 0s linear infinite;
        }
    }

    @keyframes rotate {
        0% {
            transform: translate(-50%, -50%) rotate(0deg)
        }
        100% {
            transform: translate(-50%, -50%) rotate(360deg)
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/Spinner.vue